import React from 'react';
import { Home, Tag, BookOpen, Users } from 'lucide-react';
export function IntentLinks() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-265">
      <h2 className="text-2xl font-serif text-brand-dark mb-6 text-center" data-id="element-266">
        How can Marcus help?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-267">
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-268">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-269">
            <Tag size={22} data-id="element-270" />
          </div>
          <div data-id="element-271">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-272">
              Selling a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-273">
              Every path to sell, one agent
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-274">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-275">
            <Home size={22} data-id="element-276" />
          </div>
          <div data-id="element-277">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-278">
              Buying a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-279">
              Matched by results in your neighborhood
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-280">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-281">
            <BookOpen size={22} data-id="element-282" />
          </div>
          <div data-id="element-283">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-284">
              Marcus Chen on Stan
            </p>
            <p className="text-sm text-brand-muted" data-id="element-285">
              Courses, guides & resources
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-286">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-287">
            <Users size={22} data-id="element-288" />
          </div>
          <div data-id="element-289">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-290">
              Join Our Team
            </p>
            <p className="text-sm text-brand-muted" data-id="element-291">
              Interested in joining the Chen Real Estate Group?
            </p>
          </div>
        </a>
      </div>
    </section>;
}